import { LoadingOutlined } from "@ant-design/icons";

export const SpinIcon = <LoadingOutlined style={{ fontSize: 50 }} spin />;
